import { customSessionStorage } from 'shared/lib/customStorage';

import { ST_PARENT_ID_SESSION_KEY } from '../constants/constants';

import { getStParentId } from './getStParentId';

export const setStParentIdOnce = (value: string) => {
  const existingValue = getStParentId();

  if (existingValue) {
    return existingValue;
  }

  customSessionStorage.set(ST_PARENT_ID_SESSION_KEY, value);

  return value;
};
